import UserEmploymentRecords from './UserEmploymentRecords';

export default UserEmploymentRecords;
